import { render, staticRenderFns } from "./MtConsignmentPayments.vue?vue&type=template&id=3954a4c2&scoped=true&"
import script from "./MtConsignmentPayments.vue?vue&type=script&lang=js&"
export * from "./MtConsignmentPayments.vue?vue&type=script&lang=js&"
import style0 from "./MtConsignmentPayments.vue?vue&type=style&index=0&id=3954a4c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3954a4c2",
  null
  
)

export default component.exports